import React, { useContext, useEffect } from "react";
import { useContent } from "../content/ContentProvider";
import { RouteFadeContext } from "../App";
import { ArrowLeft } from "lucide-react";

export default function Contact() {
  const { fadeTo } = useContext(RouteFadeContext);
  const { contact: CONTACT } = useContent();
  const CONTACT_IMAGE = CONTACT.image;

  useEffect(() => {
    document.title = "Contact · California Sexy";
  }, []);

  const goHome = (e) => {
    e.preventDefault();
    fadeTo("/", 600);
  };

  return (
    <div
      className="page-enter"
      style={{
        position: "relative",
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
        background: "#000",
      }}
    >
      <img
        src={CONTACT_IMAGE}
        alt=""
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          filter: "brightness(0.6) contrast(1.05) saturate(0.85)",
        }}
      />
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(ellipse at center, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.4) 70%, rgba(0,0,0,0.65) 100%)",
        }}
      />

      <a
        href="/"
        onClick={goHome}
        className="font-math"
        style={{
          position: "absolute",
          top: "1.4rem",
          left: "1.6rem",
          color: "#f4ece0",
          textDecoration: "none",
          fontSize: "0.95rem",
          display: "inline-flex",
          alignItems: "center",
          gap: "0.5rem",
          opacity: 0.85,
          zIndex: 5,
        }}
      >
        <ArrowLeft size={16} strokeWidth={1.5} />
        back
      </a>

      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#f4ece0",
          textAlign: "center",
          gap: "1.6rem",
          padding: "0 1.5rem",
        }}
      >
        <p
          className="font-math"
          style={{
            margin: 0,
            fontSize: "0.78rem",
            letterSpacing: "0.32em",
            textTransform: "uppercase",
            opacity: 0.7,
          }}
        >
          Contact
        </p>

        <h2
          className="font-math"
          style={{
            margin: 0,
            fontSize: "clamp(1.3rem, 2.2vw, 1.85rem)",
            lineHeight: 1.35,
            fontWeight: 400,
            maxWidth: "34ch",
            opacity: 0.92,
            textShadow: "0 2px 22px rgba(0,0,0,0.5)",
          }}
        >
          {CONTACT.tagline}
        </h2>

        {CONTACT.showreel && (
          <a
            href={CONTACT.showreel.url}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link font-math"
            style={{
              color: "#f4ece0",
              textDecoration: "none",
              fontSize: "clamp(1rem, 1.4vw, 1.15rem)",
              fontWeight: 600,
            }}
          >
            {CONTACT.showreel.label}
          </a>
        )}

        <div
          className="font-math"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "0.6rem",
            marginTop: "0.6rem",
            fontSize: "clamp(1rem, 1.4vw, 1.15rem)",
          }}
        >
          <a
            href={`mailto:${CONTACT.email}`}
            className="contact-link font-math"
            style={{ color: "#f4ece0", textDecoration: "none" }}
          >
            {CONTACT.email}
          </a>
          <a
            href={`tel:${CONTACT.phone.replace(/[^+\d]/g, "")}`}
            className="contact-link font-math"
            style={{ color: "rgba(244,236,224,0.78)", textDecoration: "none" }}
          >
            {CONTACT.phone}
          </a>
        </div>
      </div>

      <style>{`
        .contact-link {
          position: relative;
          display: inline-block;
          padding-bottom: 2px;
          transition: letter-spacing 400ms ease, color 400ms ease;
        }
        .contact-link::after {
          content: "";
          position: absolute;
          left: 50%; right: 50%;
          bottom: -2px;
          height: 1px;
          background: rgba(244,236,224,0.85);
          transition: left 400ms ease, right 400ms ease;
        }
        .contact-link:hover { letter-spacing: 0.04em; color: #f4ece0; }
        .contact-link:hover::after { left: 0; right: 0; }
      `}</style>
    </div>
  );
}
